module.exports = __webpack_public_path__ + "img/purple.75e5cb74.png";